import React, { useState } from "react";
import {
  NativeBaseProvider,
  Box,
  Accordion,
  Text,
  HStack,
  Avatar,
  VStack,
  Pressable,
} from "native-base";
import { Svg } from "react-native-svg";
import {
  accordionExpandCloseSVG,
  accordionExpandOpenSVG,
  speakerNoPersonSVG,
} from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import config from "../../utils/config";
import { EventPlanDetailsCards } from "../../pages/requestEventDetailPage/eventBreakdown/modalChildren/eventPlanDetailsCard";
import { SightSeeingCards } from "../../pages/requestEventDetailPage/eventBreakdown/modalChildren/sightseeingCards";

const AccordionExample = ({
  headings,
  item,
  tabActiveButton,
  index,
  handleKnowMore = () => {},
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const customStyle = {
    accordion: {
      boxShadow: "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
      border: "none",
      borderRadius: "8px",
      background:
        "linear-gradient(7.6deg, #FFDDCF -40.48%, rgba(255, 239, 196, 0.53) 80.34%)",
    },
    accordionItem: {
      background: "none",
      paddingBottom: openIndex === index ? "0" : "12px",
      // borderBottomWidth: 2,
      // borderBottomColor: COLORS.ACCORDION_BORDER_COLOR,
      borderRadius: openIndex === "null" && "8px",
    },
  };

  const handleSVG = (cond) => (
    <Svg width="24" height="24" viewBox="0 0 24 24">
      {cond === "-" ? accordionExpandOpenSVG : accordionExpandCloseSVG}
    </Svg>
  );
  function convertTo12HourFormat(time24) {
    if (time24) {
      var [hours, minutes] = time24.split(":");
      var suffix = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      return hours + ":" + minutes + " " + suffix;
    }
  }

  const accordionBody = (heading, item) => {
    if (heading === "agenda") {
      return (
        <Box width={"100%"}>
          {/* Display different session types based on their type field */}
          {item[heading] && item[heading]?.length > 0 && (
            <>
              {/* Display Speaker Sessions */}
              {item[heading]?.filter(agendaItem => agendaItem?.type === 'speaker')?.length > 0 && (
                <Box mb={3}>
                  <Text
                    fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                    mb={2}
                    color={COLORS.BLACK_COLOR}
                  >
                    Speakers Details
                  </Text>
                  {item[heading]
                    ?.filter(agendaItem => agendaItem?.type === 'speaker')
                    .map((speaker, index) => (
                      <EventPlanDetailsCards
                        key={index}
                        bg={COLORS.WHITE_COLOR}
                        body={
                          <HStack
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "15px",
                            }}
                            width={"100%"}
                            mx={"12px"}
                            mb={"16px"}   
                            mt={"6px"}
                          >
                            <Box width={"10%"}>
                              {speaker?.file_name && (
                                <Avatar 
                                  source={{ 
                                    uri: speaker?.file_name.startsWith('http') 
                                      ? speaker?.file_name 
                                      : config.bucketPath + speaker?.file_name 
                                  }} 
                                  size={"md"} 
                                />
                              )}
                              {!speaker?.file_name && (
                                <Avatar bg={"#d9d9d9"} size={"md"}>
                                  {speakerNoPersonSVG}
                                </Avatar>
                              )}
                            </Box>
                            <VStack width={"70%"}>
                              <VStack justifyContent={"center"} width={"100%"}>
                                <Text
                                  color={COLORS.BLACK_COLOR}
                                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                                  fontWeight={COMMONFONTSIZE.MEDIUM_LARGE_FONT_WEIGHT}
                                >
                                  {speaker.speaker_name}
                                </Text>
                                <Text
                                  color={COLORS.ATTACHMENTS_TEXT_COLOR}
                                  fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                                >
                                  {speaker.speaker_designation}
                                </Text>
                              </VStack>
                              <HStack
                                space={1}
                                justifyContent={"space-between"}
                                width={"100%"}
                              >
                                {(speaker.start_time || speaker.end_time) && (
                                  <HStack>
                                    <Text
                                      color={COLORS.ATTACHMENTS_TEXT_COLOR}
                                      fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                                    >
                                      Time:{" "}
                                    </Text>
                                    <Text
                                      color={COLORS.BLACK_COLOR}
                                      fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                                      fontWeight={COMMONFONTSIZE.MEDIUM_LARGE_FONT_WEIGHT}
                                    >
                                      {speaker.start_time && convertTo12HourFormat(speaker.start_time)}
                                      {speaker.start_time && speaker.end_time && ' - '}
                                      {speaker.end_time && convertTo12HourFormat(speaker.end_time)}
                                    </Text>
                                  </HStack>
                                )}
                                <Pressable
                                  onPress={() => handleKnowMore(speaker)}
                                  justifyContent={"center"}
                                >
                                  <Text
                                    color={COLORS.TOGGLE_ACTIVE_BUTTON_COLOR}
                                    fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                                  >
                                    Know More
                                  </Text>
                                </Pressable>
                              </HStack>
                            </VStack>
                          </HStack>
                        }
                      />
                    ))}
                </Box>
              )}

              {/* Display Break Sessions */}
              {item[heading].filter(agendaItem => agendaItem.type === 'break').length > 0 && (
                <Box mb={3}>
                  <Text
                    fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                    mb={2}
                    color={COLORS.BLACK_COLOR}
                  >
                    Break Details
                  </Text>
                  {item[heading]
                    .filter(agendaItem => agendaItem.type === 'break')
                    .map((breakItem, index) => (
                      <EventPlanDetailsCards
                        key={index}
                        bg={COLORS.WHITE_COLOR}
                        body={
                          <VStack p={3} space={2}>
                            <HStack justifyContent={'space-between'} width={'100%'} alignItems={'baseline'}>
                              <Text
                                fontWeight={COMMONFONTSIZE.MEDIUM_FONT_WEIGHT}
                                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                              >
                                {breakItem.title}
                              </Text>
                              {(breakItem.start_time || breakItem.end_time) && (
                                <Text
                                  color={COLORS.ATTACHMENTS_TEXT_COLOR}
                                  fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                                >
                                  {breakItem.start_time && convertTo12HourFormat(breakItem.start_time)}
                                  {breakItem.start_time && breakItem.end_time && ' - '}
                                  {breakItem.end_time && convertTo12HourFormat(breakItem.end_time)}
                                </Text>
                              )}
                            </HStack>
                            {breakItem.location && (
                              <Text color={COLORS.ATTACHMENTS_TEXT_COLOR} fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}>
                                Location : {breakItem.location}
                              </Text>
                            )}
                          </VStack>
                        }
                      />
                    ))}
                </Box>
              )}

              {/* Display Sightseeing Sessions */}
              {item[heading].filter(agendaItem => agendaItem.type === 'sightseeing').length > 0 && (
                <Box mb={3}>
                  <Text
                    fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                    fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                    mb={2}
                    color={COLORS.BLACK_COLOR}
                  >
                    Sightseeing Details
                  </Text>
                  {item[heading]
                    .filter(agendaItem => agendaItem.type === 'sightseeing')
                    .map((sightseeing, index) => (
                      <EventPlanDetailsCards
                        key={index}
                        bg={COLORS.WHITE_COLOR}
                        body={
                          <VStack p={3} space={2}>
                            <HStack justifyContent={'space-between'} width={'100%'}>
                              <Text
                                fontWeight={COMMONFONTSIZE.MEDIUM_FONT_WEIGHT}
                                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                              >
                                {sightseeing.title}
                              </Text>
                              {(sightseeing.start_time || sightseeing.end_time) && (
                                <Text
                                  color={COLORS.ATTACHMENTS_TEXT_COLOR}
                                  fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                                >
                                  {sightseeing.start_time && convertTo12HourFormat(sightseeing.start_time)}
                                  {sightseeing.start_time && sightseeing.end_time && ' - '}
                                  {sightseeing.end_time && convertTo12HourFormat(sightseeing.end_time)}
                                </Text>
                              )}
                            </HStack>
                            {sightseeing.location && (
                              <Text color={COLORS.ATTACHMENTS_TEXT_COLOR} fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}>
                                Location: {sightseeing.location}
                              </Text>
                            )}
                            {sightseeing.description && (
                              <Text color={COLORS.ATTACHMENTS_TEXT_COLOR} fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}>
                                {sightseeing.description}
                              </Text>
                            )}
                          </VStack>
                        }
                      />
                    ))}
                </Box>
              )}
            </>
          )}
        </Box>
      );
    } else if (heading === "menu" &&
      item &&
      item.menu &&
      item.menu.some(
        (obj) =>
          (obj.list.length > 0 && obj.list.some((value) => value !== "")) ||
          obj.title !== ""
      )
    ) {
      return (
        <Box width={"100%"}>
          <EventPlanDetailsCards
            bg={COLORS.WHITE_COLOR}
            body={
              <div
                style={{
                  // display: "flex",
                  // flexWrap: "wrap",
                  margin: "5px 10px 2px 14px",
                  gap: "15px",
                  width: "94%",
                }}
              >
                <VStack display={"contents"}>
                  {item.menu.map((item) => {
                    return (
                      <VStack mb={3}>
                        {item.title && (
                          <Text
                            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                            mb={2}
                          >
                            {item.title && item.title}
                          </Text>
                        )}
                        <div className="food-menu-listing">
                          {item.list?.length > 0 &&
                            item.list.map((list) => {
                              return (
                                <Box
                                  bg={COLORS.TRAVEL_PARTNERS_CARD_BGCOLOR}
                                  mt={2}
                                  py={"4px"}
                                  px={"10px"}
                                  borderRadius={"10px"}
                                  width={"fit-content"}
                                  maxW={"100%"}
                                >
                                  <Text
                                    fontWeight={
                                      COMMONFONTWEIGHT.SMALL_FONT_WEIGHT
                                    }
                                    wordBreak="break-all"
                                  >
                                    {list && list}
                                  </Text>
                                </Box>
                              );
                            })}
                        </div>
                      </VStack>
                    );
                  })}
                </VStack>
              </div>
            }
          />
        </Box>
      );
    }
  };

  return (
    <Box flex={1} width={"100%"}>
      <Accordion style={customStyle.accordion}>
        {/* {headings.map((items, index) => ( */}
        <Accordion.Item key={index} isOpen={index === openIndex}>
          <Accordion.Summary
            onClick={() => handleToggle(index)}
            style={customStyle.accordionItem}
            _hover={{ backgroundColor: "transparent" }}
          >
            <Text
              fontWeight="600"
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              color={COLORS.ACCORDION_TITLE_COLOR}
              pt={1.5}
              pb={!openIndex && 1.5}
            >
              {headings.name}
            </Text>
            {index === openIndex ? handleSVG("-") : handleSVG("+")}
          </Accordion.Summary>
          {index === openIndex && (
            <Accordion.Details style={customStyle.accordionItem}>
              <Box px={2} pb={3}>
                {accordionBody(headings.value, item[tabActiveButton])}
              </Box>
            </Accordion.Details>
          )}
        </Accordion.Item>
        {/* ))} */}
      </Accordion>
    </Box>
  );
};

export default AccordionExample;
